export enum LensGranularity {
    Week = "WEEK",
    Month = "MONTH",
    TwoMonths = "TWO_MONTHS",
    ThreeMonths = "THREE_MONTHS",
    Lifetime = "LIFETIME",
}

export const GranularityOptions = [
    { value: LensGranularity.Week, label: "Last 7 Days (UTC)" },
    { value: LensGranularity.Month, label: "Last 28 Days (UTC)" },
    { value: LensGranularity.TwoMonths, label: "Last 60 Days (UTC)" },
    { value: LensGranularity.ThreeMonths, label: "Last 90 Days (UTC)" },
    { value: LensGranularity.Lifetime, label: "All Time" },
];

export const PreviousGranularityOptions = [
    { value: LensGranularity.Week, label: "previous 7 Days" },
    { value: LensGranularity.Month, label: "previous 28 Days" },
    { value: LensGranularity.TwoMonths, label: "previous 60 Days" },
    { value: LensGranularity.ThreeMonths, label: "previous 90 Days" },
];

export const NUM_DAYS = {
    [LensGranularity.Week]: 7,
    [LensGranularity.Month]: 28,
    [LensGranularity.TwoMonths]: 60,
    [LensGranularity.ThreeMonths]: 90,
} as const;

export const GranularityInDays = {
    [LensGranularity.Week]: NUM_DAYS.WEEK,
    [LensGranularity.Month]: NUM_DAYS.MONTH,
    [LensGranularity.TwoMonths]: NUM_DAYS.TWO_MONTHS,
    [LensGranularity.ThreeMonths]: NUM_DAYS.THREE_MONTHS,
    [LensGranularity.Lifetime]: undefined,
} as const satisfies Record<LensGranularity, number | undefined>;

export const GranularityInDaysDifference = {
    [LensGranularity.Week]: GranularityInDays.WEEK * 2,
    [LensGranularity.Month]: GranularityInDays.MONTH * 2,
    [LensGranularity.TwoMonths]: GranularityInDays.TWO_MONTHS * 2,
    [LensGranularity.ThreeMonths]: GranularityInDays.THREE_MONTHS * 2,
    [LensGranularity.Lifetime]: GranularityInDays.MONTH * 2,
} as const satisfies Record<LensGranularity, number>;
